import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_All_N0_Competitions_and_Tourna_ELL,
  TXTWCL_Bet_across_our_list_of_N0_comp_ELL
} from './sportsCompetitions.messages.json';

const sportsCompetitionsWidgets = [
  {
    title: 'Sports CMS Banner Widget',
    _content_type_uid: SportsWidgetType.SportsCmsBanner,
    boxShadow: false
  },
  {
    title: 'Sports Event Type Info Widget',
    _content_type_uid: SportsWidgetType.SportsEventTypeInfo
  },
  {
    title: 'Sports Competitions Widget',
    _content_type_uid: SportsWidgetType.SportsCompetitions
  }
] satisfies readonly SectionWidgetConfig[];

export const sportsCompetitions = buildSportsLayoutPageResponse({
  alias: 'sportsCompetitions',
  seoConfig: {
    apiPath: '/meta/event-type/',
    descriptionTag: TXTWCL_Bet_across_our_list_of_N0_comp_ELL,
    redirectTo: 'sportsHome',
    redirectStatusCode: 302,
    titleTag: TXTWCL_All_N0_Competitions_and_Tourna_ELL,
    translationsMap: {
      '0': 'eventTypeName', // Translation tag was requested with %0 instead of {sport}
      sport: 'eventTypeName', // This is still needed for the description tag
      competition: 'popularCompetitions'
    }
  },
  mainSectionWidgetConfigs: sportsCompetitionsWidgets
});
